import React from 'react';
import Icon from '../icon';
import { bem, getDataAttr } from '../_libs/utils';
import { Component, PropTypes } from '../_libs';
import './style/index.scss';
class Loading extends Component {
  render() {
    const { children, position, icon } = this.props;
    const displayName = 'loading';
    const stateClassList = {
      [`is-${position}`]: position,
      [`is-${icon}`]: icon,
    };
    return (
      <div className={this.className(bem(displayName), stateClassList)} {...getDataAttr}>
        {icon === 'circle' && <p><Icon icon="loading" isAuto className={bem(displayName, 'circle')} />{children || '正在加载...' }</p>}
        {icon === 'circle-sm' && <p><Icon icon="loading" isAuto className={bem(displayName, 'circle')} />{children || '正在加载...' }</p>}
        {icon === 'dot' ? children || <div className={bem(displayName, 'dot-con')}>
          <b className={bem(displayName, 'dot')} />
          <b className={bem(displayName, 'dot')} />
          <b className={bem(displayName, 'dot')} />
        </div> : null}
        {icon === 'fail' && <p className={bem(displayName, 'text')} ><Icon icon="close-circle" isAuto className={bem(displayName, 'text-icon')} />{children || '加载失败'}</p>}
        {icon === 'success' && <p className={bem(displayName, 'text')} ><Icon icon="check-circle" isAuto className={bem(displayName, 'text-icon')} />{children || '已为您推荐10篇新闻'}</p>}
      </div>
    );
  }
}

Loading.defaultProps = {
  children: null,
  icon: 'circle',
  position: 'static',
};

Loading.propTypes = {
  // @INTRO 添加按钮内容
  children: PropTypes.node,
  // @INTRO 使用哪种图标
  icon: PropTypes.oneOf([
    'circle',
    'circle-sm',
    'dot',
    'fail',
    'success',
  ]),
  // @INTRO 定位
  position: PropTypes.oneOf([
    'static',
    'fixed',
    'absolute',
  ]),
};

export default Loading;
